import React from 'react';
import PropTypes from 'prop-types';

// This container is a basic scaffold for a website
// A custom header, footer can be supplied, as well as the page content itself
//
// A "powered by happy returns" will be shown at the bottom of the page
//
// (NOTE: this is currently used by hosted-return and tracking to structure their pages)
function Container(props) {
  return (
    <div className="box-column">
      <div className="header">{props.header}</div>
      <div className="content scroll-screen-vertical-on-desktop container">
        <div className="box-column">
          <div className="content">
            <div className={props.boxStyle}>{props.children}</div>
          </div>
          <div className="footer sticky-bottom">
            {!props.hidePoweredByHR && (
              <PoweredBy
                deactivatePoweredByLink={props.deactivatePoweredByLink}
              />
            )}
          </div>
        </div>
      </div>
      <div className="footer sticky-bottom">{props.footer}</div>
    </div>
  );
}

Container.propTypes = {
  children: PropTypes.node,
  boxStyle: PropTypes.string,
  header: PropTypes.node,
  footer: PropTypes.node,
  width: PropTypes.string,
  deactivatePoweredByLink: PropTypes.bool,
  hidePoweredByHR: PropTypes.bool,
};

function PoweredBy(props) {
  const logoUrl = `${window.ASSETS_CDN}/powered-by-hr-wide.png`;

  return (
    <div className="text-center" style={{ paddingTop: '24px', marginBottom: '24px' }}>
      {props.deactivatePoweredByLink ? (
        <img
          src={logoUrl}
          alt="Powered by Happy Returns"
          width="243"
        />
      ) : (
        <a href="https://www.happyreturns.com" target="_blank" rel="noopener noreferrer">
          <img
            src={logoUrl}
            alt="Powered by Happy Returns"
            width="243"
          />
        </a>
      )}
    </div>
  );
}

PoweredBy.propTypes = {
  deactivatePoweredByLink: PropTypes.bool,
};

export default Container;
